import {Api, apiFetch} from "../_helpers/api";
import {createQueryParameters, getCurrentUser, to_url} from "../_helpers/utils";
import User from "../_data/models/User";
import * as ts from "typescript/lib/tsserverlibrary";
import Err = ts.server.Msg.Err;
import Shop from "../_data/models/Shop";

const ShopRepository = {
    listByUser: (user: User, cursor: number = null, page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({user: user.id, cursor: cursor, page: page, per_page: perPage, is_cursor: true});
        return apiFetch(to_url(Api.apiBaseUrl, 'salons') + query)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    return {
                        error: true,
                        response: response
                    };
                }
            });
    },

    getShopProfessionals: (shopId: number, cursor: number = null, page: number = null, perPage: number = 5) => {
        const query = createQueryParameters({cursor: cursor, page: page, per_page: perPage, is_cursor: true});
        return apiFetch(to_url(Api.apiBaseUrl, 'salons', shopId, "professionals") + query)
            .then(response => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                }
                else {
                    return {
                        error: true,
                        response: response
                    };
                }
            });
    }
};

export default ShopRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/shopRepository.ts